import { Checkbox, styled, TableRow } from "@mui/material";
import { ReactNode } from "react";
import { SendingAddressesMap } from "src/views/AssetManagement/BatchApproveAllowance/contexts/PreviewContext";
import { TABLE_COLUMNS, TableColumnId } from "../../constants/tableColumns";
import StyledTableCell from "../../components/StyledTableCell";
import OverflowTooltipText from "src/components/OverflowTooltipText";

const StyledTableRow = styled(TableRow)({
  background: "#eaeaea",
  ":hover": {
    background: "#e1e1e1",
  },
  "&:last-of-type": { border: "0px" },
});

type TableBodyRowProps = {
  serialNumber: number;
  sendingAddress: string;
  senderInfo: SendingAddressesMap extends Map<string, infer T> ? T : never;
  spenderAddress: string;
  toDisplayAmountWithCurrency: (amount: string | number) => string;
  onToggleAddress: (sendingAddress: string, isChecked: boolean) => void;
};

function TableBodyRow({
  serialNumber,
  sendingAddress,
  senderInfo,
  spenderAddress,
  toDisplayAmountWithCurrency,
  onToggleAddress,
}: TableBodyRowProps) {
  const { walletBalance, isSelected } = senderInfo;

  const cellNodeByColumnId: Record<TableColumnId, ReactNode> = {
    serial_number: <OverflowTooltipText text={serialNumber} />,
    sending_address: <OverflowTooltipText text={sendingAddress} copyable />,
    // spender_address: <OverflowTooltipText text={spenderAddress} copyable />,
    select_all: (
      <Checkbox
        checked={isSelected}
        onChange={(event) => {
          onToggleAddress(sendingAddress, event.target.checked);
        }}
      />
    ),
    wallet_balance: (
      <OverflowTooltipText text={toDisplayAmountWithCurrency(walletBalance)} />
    ),
  };

  return (
    <StyledTableRow key={sendingAddress}>
      {TABLE_COLUMNS.map((column) => (
        <StyledTableCell
          key={column.id}
          align="center"
          sx={{ minWidth: column.minWidth }}
        >
          {cellNodeByColumnId[column.id]}
        </StyledTableCell>
      ))}
    </StyledTableRow>
  );
}

export default TableBodyRow;
